import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const Slider = ({ props }) => {

    const allPathEdit = props.split("/");

    useEffect(() => {
        if (props == "/SliderList" || props == "/SliderAdd" || allPathEdit[1] == "SliderEdit") {
            document.getElementById("collapseSlider").classList.add("show");
        }
    }, [])


    return (
        <li className="sidebar-dropdown mabot_mainli">
            <Link to="#" data-toggle="collapse" data-target="#collapseSlider">
                <span>Sliders</span>
                <i className="fa admin-ico admin-ico--sliders"></i>
            </Link>
            <div className="sidebar-submenu" id="collapseSlider" class="collapse" data-parent="#accordion">
                <ul>
                    <li>
                        <Link to="/SliderList">Sliders</Link>
                    </li>
                </ul>
            </div>
        </li>
    )
}

export default Slider
